import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { ModalComponent } from '@fcom/ui-components/components/modal/modal.component';
import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { ToggleSwitchComponent } from '@fcom/ui-components/components/toggle-switch/toggle-switch.component';
import { CmsModule } from '@fcom/cms';

import { DirectiveModule } from '../../directives/directive.module';
import { FinFormsModule } from '../../forms/forms.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../components.module';
import { CookiePolicyComponent } from './cookie-policy.component';
import { CookieSettingsComponent } from './cookie-settings.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    PipesModule,
    CmsModule,
    FinFormsModule,
    FormsModule,
    UiTranslateModule,
    IconComponent,
    ModalComponent,
    ButtonComponent,
    ToggleSwitchComponent,
  ],
  declarations: [CookiePolicyComponent, CookieSettingsComponent],
  exports: [CookiePolicyComponent],
})
export class CookiePolicyModule {}
